// IP allowlist API client (MOD-04 / SRV-IP) — security.manage.
//
// Uçlar `/api/v1/admin/ip-allowlist`; CRUD. POST/PUT dönen entry'yi taşır
// (IpAllowlistEntryDtoActionResponse), o yüzden re-fetch gerekmez. İş kuralları
// BE'de: geçersiz CIDR (INVALID_CIDR/422), yinelenen kural (DUPLICATE_CIDR/
// CONFLICT/409) → anlamlı mesaj.

import { http, unwrap, unwrapList, type ActionResponse } from './http';
import type {
  CreateIpAllowlistRequest,
  IpAllowlistEntry,
  IpAllowlistEntryDtoWire,
  IpAllowlistInput,
  UpdateIpAllowlistRequest,
} from '@features/ip-allowlist/types';

function mapEntry(d: IpAllowlistEntryDtoWire): IpAllowlistEntry {
  return {
    id: d.id ?? '',
    cidr: d.cidr ?? '',
    label: d.label ?? '',
    enabled: d.enabled ?? false,
    createdAt: d.createdAt ?? '',
    updatedAt: d.updatedAt ?? '',
  };
}

export const ipAllowlistApi = {
  async list(): Promise<IpAllowlistEntry[]> {
    const res = await http.get<ActionResponse<IpAllowlistEntryDtoWire>>(
      '/api/v1/admin/ip-allowlist',
    );
    const { items } = unwrapList(res);
    return items.map(mapEntry);
  },

  async create(input: IpAllowlistInput): Promise<IpAllowlistEntry> {
    const body: CreateIpAllowlistRequest = {
      cidr: input.cidr,
      label: input.label,
      enabled: input.enabled,
    };
    const res = await http.post<ActionResponse<IpAllowlistEntryDtoWire>>(
      '/api/v1/admin/ip-allowlist',
      body,
    );
    return mapEntry(unwrap(res));
  },

  async update(id: string, input: IpAllowlistInput): Promise<IpAllowlistEntry> {
    const body: UpdateIpAllowlistRequest = {
      cidr: input.cidr,
      label: input.label,
      enabled: input.enabled,
    };
    const res = await http.put<ActionResponse<IpAllowlistEntryDtoWire>>(
      `/api/v1/admin/ip-allowlist/${id}`,
      body,
    );
    return mapEntry(unwrap(res));
  },

  async remove(id: string): Promise<void> {
    const res = await http.delete<ActionResponse<boolean>>(
      `/api/v1/admin/ip-allowlist/${id}`,
    );
    unwrap(res);
  },
};
